/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { externalCredentialsGetGcpSetupInfo } from "../funcs/externalCredentialsGetGcpSetupInfo.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GcpSetupInfo } from "../models/components/gcpsetupinfo.js";
import {
  GetGcpSetupInfoRequest,
  GetGcpSetupInfoSecurity,
} from "../models/operations/getgcpsetupinfo.js";
import { unwrapAsync } from "../types/fp.js";
export type GcpSetupInfoQueryData = GcpSetupInfo;

export function prefetchGcpSetupInfo(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetGcpSetupInfoRequest | undefined,
  security?: GetGcpSetupInfoSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGcpSetupInfoQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGcpSetupInfoQuery(
  client$: GramCore,
  request?: GetGcpSetupInfoRequest | undefined,
  security?: GetGcpSetupInfoSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GcpSetupInfoQueryData>;
} {
  return {
    queryKey: queryKeyGcpSetupInfo({ gramSession: request?.gramSession }),
    queryFn: async function gcpSetupInfoQueryFn(
      ctx,
    ): Promise<GcpSetupInfoQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(externalCredentialsGetGcpSetupInfo(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGcpSetupInfo(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "externalCredentials", "getGcpSetupInfo", parameters];
}
